import moment from "moment";
import ls from "localstorage-slim";

export const isTimeOut = (timeout = process.env.REACT_APP_SESSION_TIMEOUT) => {
  let savedTimeout = parseInt(ls.get("DTimeout")) || moment().format("x");
  let currentTimeOut = moment().format("x");

  if (currentTimeOut - savedTimeout < timeout) {
    ls.set("DTimeout", moment().format("x"));
    return false;
  }
  return true;
};

export function displayIfPropertyExists(object, property, todisplay) {
  if (
    object &&
    object.hasOwnProperty(property) &&
    object[property] !== null &&
    object[property] !== undefined
  ) {
    return todisplay;
  }
  return "";
}

// configs/report-auto/form
export const getReportingType = (data, key) => {
  if (!data?.length) return null;
  return data.find((item) => item.value === key) || null;
};
